// Copyright (c) 2019 Deere & Company

import {
    updateOktaIsAuthenticated,
    updateOktaUserId,
    updateOktaUserName,
} from './okta-state';

export default {
    updateOktaIsAuthenticated,
    updateOktaUserId,
    updateOktaUserName,
};
